module.exports = __webpack_public_path__ + "static/img/help_02class_08.e07247f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_08.png
// module id = 688
// module chunks = 140